module.exports = __webpack_public_path__ + "fonts/HelveticaNeueCyrBold.725c545.eot";